export type DownloadAllButtonIconProps = {
  color: string;
  height: number;
  width: number;
};

/**
 * "Download all" (ZIP) glyph used inside the download-all button — a
 * download-to-tray arrow with a "ZIP" label. Shared by the transfer success
 * page and the Drive share-link viewer.
 */
export function DownloadAllButtonIcon({
  color,
  height,
  width,
}: DownloadAllButtonIconProps) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill={color}
        viewBox="0 0 18.767 15.796"
      >
        <g
          id="Gruppe_1407"
          data-name="Gruppe 1407"
          transform="translate(0.136 -1.734)"
        >
          <path
            id="Pfad_55"
            data-name="Pfad 55"
            d="M1.477-.791H3.516V0H.193V-.542l2.033-2.93H.182v-.794H3.5v.527ZM5.077,0H4.052V-4.266H5.077ZM6.82-1.447V0H5.792V-4.266h1.7a1.983,1.983,0,0,1,.866.18,1.358,1.358,0,0,1,.583.513,1.4,1.4,0,0,1,.207.754,1.234,1.234,0,0,1-.447,1,1.854,1.854,0,0,1-1.226.374Zm0-.794h.674a.635.635,0,0,0,.456-.149.555.555,0,0,0,.157-.422.686.686,0,0,0-.161-.478.571.571,0,0,0-.439-.182H6.82Z"
            transform="translate(9.481 6)"
          />
          <path
            id="arrow-to-bottom"
            d="M11.453,38.576,6.589,43.453a.4.4,0,0,1-.559,0L1.167,38.576a.4.4,0,0,1,0-.559l.644-.644a.39.39,0,0,1,.562.007l3.079,3.191V32.394A.4.4,0,0,1,5.846,32h.92a.4.4,0,0,1,.394.394v8.176L10.24,37.38a.4.4,0,0,1,.562-.007l.644.644A.389.389,0,0,1,11.453,38.576Zm.772,6.438H.394A.4.4,0,0,0,0,45.408v.92a.4.4,0,0,0,.394.394H12.225a.4.4,0,0,0,.394-.394v-.92A.4.4,0,0,0,12.225,45.014Z"
            transform="translate(-0.136 -29.192)"
          />
        </g>
      </svg>
    </div>
  );
}
